<div #contextContainer
    class="fixed flex flex-col bg-ponder-light rounded text-slate-200 w-64 z-50 card-shadow pb-1 text-sm" 
    [ngClass]="{ 'invisible' : !isVisible }">
    @if (previewItem) {
        <preview-item-context-normal [previewItem]="previewItem!"></preview-item-context-normal>
        <preview-item-context-special [previewItem]="previewItem!"></preview-item-context-special>
        <preview-item-context-proxy [previewItem]="previewItem!"></preview-item-context-proxy>

        <div class="bg-faded-10 w-full min-h-[1px] mt-1 mb-1"></div>

        <preview-item-context-open-tab [previewItem]="previewItem!"></preview-item-context-open-tab>
        <preview-item-context-add-to-deck [parentRef]="this" [previewItem]="previewItem.previewItem!.item!"></preview-item-context-add-to-deck>

        <div class="bg-faded-10 w-full min-h-[1px] mt-1 mb-1"></div>

        <preview-item-context-set-avatar [parentRef]="this" [previewItem]="previewItem.previewItem!.item!"></preview-item-context-set-avatar>
    }
</div>
<add-card-to-deck-modal></add-card-to-deck-modal>